import { defineMessages } from 'react-intl';

export default defineMessages({
    HomeDetails: {
        id: 'policy.common.component.policy-dwelling-info.Occupancy TypeN',
        defaultMessage: 'Home Details'
    },
    noScheduleItems: {
        id: 'portal.views.home-page-layout.No Schedule Items available',
        defaultMessage: 'No Schedule Items available'
    }
});
